export const CHAIN = Object.freeze({
  chainId: "ipi-testnet-1",
  chainName: "IPI Testnet",
  rpc: "https://rpc-testnet.ipi.io",
  websocket: "wss://ws-testnet.ipi.io/websocket",
  rest: "https://rest-testnet.ipi.io",
  addressPrefix: "ipi",
  baseDenom: "aipi",
  displayDenom: "IPI",
  decimals: 18,
  coinType: 60,
  checkoutTypeUrl: "/ipi.checkout.v1.MsgExecuteCheckoutV2",
  pubkeyTypeUrl: "/cosmos.evm.crypto.v1.ethsecp256k1.PubKey",
  signingMode: "SIGN_MODE_DIRECT",
});

export const KEPLR_CHAIN_INFO = Object.freeze({
  rpc: CHAIN.rpc,
  rest: CHAIN.rest,
  chainId: CHAIN.chainId,
  chainName: CHAIN.chainName,
  stakeCurrency: {
    coinDenom: CHAIN.displayDenom,
    coinMinimalDenom: CHAIN.baseDenom,
    coinDecimals: CHAIN.decimals,
  },
  bip44: { coinType: CHAIN.coinType },
  bech32Config: {
    bech32PrefixAccAddr: "ipi",
    bech32PrefixAccPub: "ipipub",
    bech32PrefixValAddr: "ipivaloper",
    bech32PrefixValPub: "ipivaloperpub",
    bech32PrefixConsAddr: "ipivalcons",
    bech32PrefixConsPub: "ipivalconspub",
  },
  currencies: [{
    coinDenom: CHAIN.displayDenom,
    coinMinimalDenom: CHAIN.baseDenom,
    coinDecimals: CHAIN.decimals,
  }],
  feeCurrencies: [{
    coinDenom: CHAIN.displayDenom,
    coinMinimalDenom: CHAIN.baseDenom,
    coinDecimals: CHAIN.decimals,
    gasPriceStep: {
      low: 1_000_000_000,
      average: 1_500_000_000,
      high: 2_000_000_000,
    },
  }],
  features: ["eth-address-gen", "eth-key-sign", "eth-secp256k1-cosmos"],
});

export const PROBE_NETWORK_POLICY = Object.freeze({
  accountQuery: "read-only",
  signDirect: true,
  simulate: false,
  broadcast: false,
});
